module.exports = __webpack_public_path__ + "static/media/bubble-2.23a62d8d.png";